module.exports = __webpack_public_path__ + "img/b.d662ff2d.jpg";